import { status } from 'skin/event/status';
import dlt from './delete';

const menuExc = (obj, form, story, data, d, action) => {
	switch (obj.action) {
		case 'delete':
			return dlt(obj, form, story, data, d, action);
		default:
	}
	return status.action;
};

export default menuExc;
